import React, { useRef, useState, useEffect, useDebugValue } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import AddHeaderSlider from 'src/components/headers/AddHeaderSlider';
import { CForm, CFormLabel, CFormInput, CButton, CCard, CCardBody, CCardHeader, CCol, CRow, } from '@coreui/react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import PageInfoList from 'src/components/page-info/PageInfoList';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import Tab from 'react-bootstrap/Tab';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import GalleryObject from 'src/components/gallery/GalleryObject';
import LangugesPanel from './LangugesPanel';

const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };

const urlApi = '/pages';
const urlRouter = '/site-pages';

const navNames = {
  info: 'Загальні',
  // models: 'Модель',
  slider: 'Слайдер',
  // img: 'Зображення',
  gallery: 'Галерея',
  // attributes: 'Атрибути',
  // category: 'Категоріі',
  data: 'Додаткові дані',
  // publications: 'Публікаціі'
  // scannings: 'Сканування',
};

export async function LoaderPagesUpdate({ params }) {
  if (Object.keys(params).length != 0 && params.id != undefined) {
    let res = await AxiosInstance.get(`${urlApi}/${params.id}`,
      {
        params: {
          "g[0]": "page:read",
          "g[1]": "page:galleries",
          "g[2]": "page:pageInfos",
          "g[3]": "page:translation"
        }
      }
    ).then((response) => {
      response['type'] = (params.type != undefined) ? params.type : "page";
      console.log(response);
      return response;
    });
    return res;
  };

  return { type: (params.type != undefined) ? params.type : 'page' };
};


const pagesForm = ({ user_data }) => {
  if (!Permissions(user_data, 'Pages', 'EDIT_PAGES')) {
    return <PermissionsNoPage />;
  }
  const navigate = useNavigate();
  const { data, type } = useLoaderData();
  const [myData, setMyData] = useState((data != undefined) ? data : false);

  const [name, setName] = useState(myData ? myData.name : '');
  const [pageType, setPageType] = useState((type != undefined) ? type : 'page');
  const [synonym, setSynonym] = useState(myData ? myData.synonym : '');
  const [mainImg, setmainImg] = useState(myData ? myData.images : '');
  const [sliders, setSliders] = useState((myData && myData.slider != undefined) ? myData.slider.id : false);
  const [language, setLaguage] = useState('');

  // стан для запису eventKey активного навлінка,показувати чи не показувати svg
  const [activeKey, setActiveKey] = useState('info')
  const [navLinkName, setNavLinkName] = useState('Загальні')

  const editorRef = useRef(null);

  const popup = MyToastify();
  // Ключ для Editor
  const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;

  // Викликає popup з власного компонента
  // Текст для popup
  const popupTextPostSuccess = "Сторінку створено";
  const popupTextPutSuccess = "Сторінку змінено";

  useEffect(() => {
    if (data) {
      setMyData(data);
      setPageType(data.type || 'page');
      setSynonym(data.synonym || '');
      setmainImg(data.images || '');
      setSliders(data.slider ? data.slider.id : false);
      setName(data.name || '');
    }
  }, [data]);

  const handleSubmit = event => {
    event.preventDefault();
    if (editorRef.current) {
      // Перевірка, чи synonym вже містить ключ
      const suffix = data?.language?.key || 'ua';
      const regex = new RegExp(`_${suffix}$`);
      const finalSynonym = regex.test(synonym) ? synonym : `${synonym}_${suffix}`;

      const article = {
        name: name,
        synonym: finalSynonym,
        type: pageType,
        content: editorRef.current.getContent(),
        active: 'on',
        images: mainImg,
      };

      if (data != undefined) {
        article.language = data.language ? `/api/languages/${data.language.id}` : `/api/languages/1`;
        AxiosInstance.put(`${urlApi}/${data.id}`, article).then((response) => {
          if (response.status === 200) {
            setSynonym(finalSynonym);
            popup.toastifySuccess(popupTextPutSuccess);
          }
        });
      } else {
        article.language = `/api/languages/1`;
        AxiosInstance.post(urlApi, article).then((response) => {
          if (response.status === 201) {
            setSynonym(finalSynonym);
            popup.toastifySuccess(popupTextPostSuccess);
            if (type == undefined || type == 'page' || type == '')
              return navigate(`${urlRouter}/update/${response.data.id}`);
            else
              return navigate(`/p/${type}/${response.data.id}`);
          }
        });
      }
    }
  };


  // console.log(myData);

  return (
    <div className='component_wrapper'>
      <ToastContainer />

      {/* <h2>{navLinkName}</h2>
        <hr />
      
        <div className='col d-flex justify-content-end'>
          {data !== undefined && <LangugesPanel data={myData} setMyData={setMyData} setLaguage={setLaguage} language={language} />}
        </div> */}


      <Tab.Container id="left-tabs-example" defaultActiveKey="info"
        onSelect={(key) => {
          setActiveKey(key);
          setNavLinkName(navNames[key]);
        }}

      >
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link className='styled_nav_link' eventKey="info">
                  {activeKey === 'info' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="4" cy="4" r="4" fill="#227965" />
                  </svg>}
                  Загальні</Nav.Link>
              </Nav.Item>
              {data !== undefined && <>
                <Nav.Item>
                  <Nav.Link className='styled_nav_link' eventKey="slider">
                    {activeKey === 'slider' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Слайдер</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link className='styled_nav_link' eventKey="gallery">
                    {activeKey === 'gallery' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Галерея</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className='styled_nav_link' eventKey="data">
                    {activeKey === 'data' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Дані сторінки</Nav.Link>
                </Nav.Item>
              </>}
            </Nav>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              <div style={{ display: 'flex' }}>
                <div className='tab-content-title'>
                  <h2>{navLinkName}</h2>
                  <hr />
                </div>
                <div className='col d-flex justify-content-end'>
                  {data !== undefined && <LangugesPanel data={myData} setMyData={setMyData} setLaguage={setLaguage} language={language} />}
                </div>
              </div>


              <Tab.Pane eventKey="info">
                {/* <AddHeaderSlider id={(sliders !== false) ? sliders : undefined} newSlider={setSliders} parentUrl={`pages/${data?.id}`} /> */}
                <CForm onSubmit={handleSubmit}>
                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
                    <CFormInput type="text" id="exampleFormControlInput1"
                      value={name}
                      // value={myData?.name}
                      onChange={(e) => setName(e.target.value)} autoComplete="off" />
                  </div>
                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Синонім</CFormLabel>
                    <CFormInput type="text" id="exampleFormControlInput2"
                      value={synonym}
                      // value={myData?.synonym}
                      onChange={(e) => setSynonym(e.target.value)} autoComplete="off" />
                  </div>
                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Тип</CFormLabel>
                    <CFormInput type="text" id="exampleFormControlInput2"
                      value={pageType}
                      // value={myData?.type}
                      onChange={(e) => setPageType(e.target.value)} autoComplete="off" disabled={(type == undefined || type == 'page') ? false : true} />
                  </div>
                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Головне зображення</CFormLabel>
                    <CFormInput type="text" id="exampleFormControlInput3"
                      value={mainImg}
                      // value={myData?.mainImg}
                      onChange={(e) => setmainImg(e.target.value)} autoComplete="off" />
                    <Link to="/media" target='_blanck'>перейти до медіа</Link>
                  </div>
                  <div className="mb-3" style={{ marginTop: '40px' }}>
                    <h3 className='editor-title'>Description</h3>
                    <Editor
                      apiKey={apiKey}
                      onInit={(evt, editor) => editorRef.current = editor}
                      initialValue={(data != undefined) ? data.content : ''}
                      init={{
                        height: 500,
                        menubar: 'edit view insert format',
                        plugins: [
                          'advlist', 'autolink',
                          'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
                          'insertdatetime', 'media', 'table', 'help', 'code'
                        ],
                        toolbar: 'undo redo | fontfamily fontsize | fontselect | bold italic backcolor | ' +
                          'alignleft aligncenter alignright alignjustify | ' +
                          'bullist numlist checklist outdent indent | removeformat | link media a11ycheck code table help',
                        content_style: 'body { font-family:FixelDisplayRegular; font-size:14px }',
                        font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Fixel Display Regular=fixelDisplayRegular; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                      }}
                    />
                  </div>
                  <CButton className='item_add_button_left' type="submit" color="success">Save</CButton>
                </CForm>
              </Tab.Pane>
              {data !== undefined &&
                <>
                  <Tab.Pane eventKey="slider">
                    <AddHeaderSlider id={(sliders !== false) ? sliders : undefined} newSlider={setSliders} parentUrl={`pages/${data?.id}`} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="data">
                    <PageInfoList id={data.id} type="page" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="gallery">
                    <GalleryObject dataId={data.id} popup={popup} typeChain={'pages'} currentGalleries={data.galleries} />
                  </Tab.Pane>
                </>}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>

  );
};

export default pagesForm;
